import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Fragment } from 'react';
import { useIsKeyHeld } from './useIsKeyHeld.es.js';

const Styles = labelStyles("VisuallyHidden", {
  root: css`
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    height: 1px;
    width: 1px;
    margin: -1px;
    padding: 0;
    border: 0;
  `
});
const VisuallyHidden = (props) => {
  const isAltKeyHeld = useIsKeyHeld("Alt");
  if (isAltKeyHeld) {
    return jsx(Fragment, null, props.children);
  }
  return jsx("span", { css: Styles.root, "data-testid": "visually-hidden" }, props.children);
};

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.es.js.map
